module.exports = __webpack_public_path__ + "img/window.d5eeaa05.svg";